import { useEffect, useMemo, useRef } from 'react';
import { createUploadSession } from './session';

export default function useUploadSession(studioContext, authContext) {
  const { assetType, storyId, resourceId, studioStoryId, studioDefinitionId } =
    studioContext || {};
  const tenantName = authContext?.tenant?.name;
  const scope = useMemo(
    () => ({
      authContext,
      tenantName,
      assetType,
      storyId,
      resourceId,
      studioStoryId,
      studioDefinitionId,
    }),
    [
      authContext,
      tenantName,
      assetType,
      storyId,
      resourceId,
      studioStoryId,
      studioDefinitionId,
    ]
  );
  const scopeRef = useRef(scope);
  scopeRef.current = scope;
  const session = useMemo(
    () => createUploadSession(() => scopeRef.current === scope),
    [scope]
  );
  useEffect(() => () => session.dispose(), [session]);
  return session;
}
